import { useEffect, useRef, useState } from "react";
import { GuestCardSurface } from "@/features/guest-invite/GuestCardSurface";
import type { InvitationCardBlockDto } from "@/lib/api/types";

export function TemplatePreview({ blocks }: { blocks: InvitationCardBlockDto[] }) {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      style={{
        width: "100%",
        aspectRatio: "5 / 7",
        position: "relative",
        overflow: "hidden",
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          width: 500,
          height: 700,
          transform: `scale(${width / 500})`,
          transformOrigin: "top left",
        }}
      >
        <GuestCardSurface blocks={blocks} />
      </div>
    </div>
  );
}
